import { RegistrationEmail } from 'cpnl-common';
import * as Yup from 'yup';

export const registrationEmailValidationSchema = (registrationEmail: RegistrationEmail): Yup.ObjectSchema => {
    return Yup.object().shape({
        email: Yup.string().trim().required(registrationEmail.email.empty).email(registrationEmail.email.invalid),
    });
};
